// extracted by mini-css-extract-plugin
module.exports = {"boxMessage":"BoxMessage_boxMessage__1oNR9","postButton":"BoxMessage_postButton__3vB5V"};